// extracted by mini-css-extract-plugin
export default {"obraL1":"ObraL1_obraL1__qBbdo","smallPiegraph":"ObraL1_smallPiegraph__bdPOt"};